<template>
  <main id="js-page-content" role="main" class="page-content"></main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Empty extends Vue {}
</script>
